import type { CSSProperties } from "react";
// import {
//   CircularLoadingSpinner,
//   CircularLoadingSpinnerProps,
// } from "./CircularLoadingSpinner/CircularLoadingSpinner";

export interface LoadingOverlayProps {
  // size?: CircularLoadingSpinnerProps["size"];
  style?: CSSProperties;
  fullScreen?: boolean;
  show?: boolean;
  text?: string;
}

export function LoadingOverlay({
  // size = "large",
  style,
  fullScreen,
  show,
  text,
}: LoadingOverlayProps) {
  return (
    <div
      style={{
        position: fullScreen ? "fixed" : "absolute",
        inset: 0,
        alignContent: "center",
        textAlign: "center",

        background: "rgba(0, 0, 0, 0.5)",
        color: "white",

        ...(show !== undefined
          ? {
              transitionProperty: "opacity, contentVisibility, pointer-events",
              transitionDuration: "300ms",
              transitionTimingFunction: "linear",
              transitionBehavior: "allow-discrete",

              opacity: show ? 1 : 0,
              contentVisibility: show ? "visible" : "hidden",
              pointerEvents: show ? "all" : "none",
            }
          : {}),

        ...style,
      }}
    >
      {/* <CircularLoadingSpinner size={size} fillWidth /> */}
      {text && <h3>{text}</h3>}
    </div>
  );
}
